import { render } from "./TourBookingBanner.vue?vue&type=template&id=ae2c5334"
import script from "./TourBookingBanner.vue?vue&type=script&lang=js"
export * from "./TourBookingBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__